/* Silvery Silver homepage (2026-10 redesign): collection carousel buttons and Top Styles tabs.
   No dependencies, no autoplay. Safe to load more than once (guards on window and on each element). */
(function () {
  if (window.ssHomeLoaded) return;
  window.ssHomeLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Carousel: prev/next buttons for a scroll-snap track ---------- */
  function initCarousel(root) {
    if (root.dataset.ssBound) return;
    root.dataset.ssBound = '1';
    var track = root.querySelector('[data-ss-track]');
    var prev = root.querySelector('[data-ss-prev]');
    var next = root.querySelector('[data-ss-next]');
    if (!track || !prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 4;
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
      root.classList.toggle('is-scrollable', scrollable);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }
    function step(dir) {
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 200), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    update();
  }

  /* ---------- Tabs (WAI-ARIA pattern, manual activation on click, arrows move and select) ---------- */
  function initTabs(root) {
    if (root.dataset.ssBound) return;
    root.dataset.ssBound = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      if (tab.scrollIntoView && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
        var list = tab.parentElement;
        var left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
        list.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowRight') to = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') to = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') to = tabs[0];
        else if (e.key === 'End') to = tabs[tabs.length - 1];
        if (to) { e.preventDefault(); select(to, true); }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ss-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-ss-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Theme editor: re-run when sections are added or re-rendered. */
  document.addEventListener('shopify:section:load', init);
})();
